import React from 'react';
import type { I18nLike } from '@bingads-webui/common-types';
import PropTypes from 'prop-types';
import { ArrowClockwiseFilled } from '@fluentui/react-icons';
import { mergeClasses } from '@fluentui/react-components';
import {
  EmptyState,
  EmptyStateAction,
  EmptyStateButton,
  EmptyStateContent,
  EmptyStateSize,
  EmptyStateSurfaceIcon,
  SurfaceIcons,
} from '@adsui/empty-state';
import { useFluentErrorViewStyles } from './fluent-error-view-styles';

export type FluentErrorViewI18n = I18nLike;

export interface FluentErrorViewProps {
  className?: string;
  i18n: FluentErrorViewI18n;
  showRefresh?: boolean;
}

export function FluentErrorView({
  className,
  i18n,
  showRefresh,
}: FluentErrorViewProps) {
  const styles = useFluentErrorViewStyles();
  const title = i18n.getString(_TL_('Well, that\'s unexpected'));
  const subtext = [
    i18n.getString(_TL_('Microsoft Advertising isn\'t available right now, but everything should be back to normal very soon.')),
    '',
    i18n.getString(_TL_('Don\'t worry about your ads - this doesn\'t impact them.')),
  ];

  return (
    <EmptyState className={mergeClasses(className, styles.emptyStateContainer)} size={EmptyStateSize.largeSurface}>
      <EmptyStateContent
        title={title}
        subtext={subtext}
      >
        <EmptyStateSurfaceIcon icon={SurfaceIcons.SearchQuestionMark} />
      </EmptyStateContent>
      <EmptyStateAction>
        {showRefresh && (
          <EmptyStateButton
            appearance="secondary"
            icon={<ArrowClockwiseFilled />}
            onClick={() => window.location.reload()}
          >
            {i18n.getString(_TL_('Refresh page'))}
          </EmptyStateButton>
        )}

      </EmptyStateAction>
    </EmptyState>
  );
}

FluentErrorView.propTypes = {
  className: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  showRefresh: PropTypes.bool,
};

FluentErrorView.defaultProps = {
  className: '',
  showRefresh: true,
};
